import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '@ohif/ui';

// Route Components
import buildModeRoutes from './buildModeRoutes';
import Dashboard from './Dashboard';
import DataSourceWrapper from './DataSourceWrapper';
import ForgotPassword from './ForgotPassword';
import Login from './Login';
import { NotFound, NotFoundServer, NotFoundStudy } from './NotFound';
import ResetPassword from './ResetPassword';
import WorkList from './WorkList';
import Workspace from './Workspace';


const defaultRoutes = [
  {
    path: '/overview',
    children: Dashboard,
  },
  {
    path: '/login',
    children: Login,
  },
  {
    path: '/login/forgot-password',
    children: ForgotPassword,
  },
  {
    path: '/login/reset-password',
    children: ResetPassword,
  },
  {
    path: '/notfoundserver',
    children: NotFoundServer,
  },
  {
    path: '/notfoundstudy',
    children: NotFoundStudy,
  },
  {
    path: '/overview',
    children: Dashboard,
  },
  {
    path: '/workspace/:workspaceId',
    children: Workspace,
  },
  {
    path: '/*',
    children: NotFound,
  },
];

// NOT FOUND (404)
const notFoundRoute = { component: NotFound };

const AppRoutes = ({
  modes,
  dataSources,
  extensionManager,
  servicesManager,
  commandsManager,
  hotkeysManager,
  routerBasename,
  showStudyList,
}) => {
  const routes =
    buildModeRoutes({
      modes,
      dataSources,
      extensionManager,
      servicesManager,
      commandsManager,
      hotkeysManager,
    }) || [];

  const { customizationService } = servicesManager.services;

  const WorkListRoute = {
    path: '/',
    children: DataSourceWrapper,
    private: true,
    props: { children: WorkList, servicesManager, extensionManager },
  };

  const customRoutes = customizationService.getGlobalCustomization('customRoutes');
  const allRoutes = [
    ...routes,
    ...(showStudyList ? [WorkListRoute] : []),
    ...(customRoutes?.routes || []),
    ...defaultRoutes,
    customRoutes?.notFoundRoute || notFoundRoute,
  ];

  function RouteWithErrorBoundary({ route, ...rest }) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (
      <ErrorBoundary
        context={`Route ${route.path}`}
        fallbackRoute="/"
      >
        <route.children
          {...rest}
          {...route.props}
          route={route}
          servicesManager={servicesManager}
          extensionManager={extensionManager}
          hotkeysManager={hotkeysManager}
        />
      </ErrorBoundary>
    );
  }

  return (
    <Routes>
      {allRoutes.map((route, i) => (
        <Route
            key={i}
            path={route.path}
            element={<RouteWithErrorBoundary route={route} />}
          />
      ))}
    </Routes>
  );
};

export default AppRoutes;
